import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import FooterSection from '../home-landing/components/FooterSection';
import ReservationHero from './components/ReservationHero';



import Icon from '../../components/AppIcon';

const Reservations = () => {
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState(0);
  const [user, setUser] = useState(null);

  const handleCartClick = () => {
    navigate('/shopping-cart');
  };

  const handleAccountClick = (action) => {
    switch (action) {
      case 'login':navigate('/login');
        break;
      case 'register':navigate('/register');
        break;
      case 'account':navigate('/user-account');
        break;
      case 'logout':localStorage.removeItem('currentUser');
        setUser(null);
        break;
      default:
        break;
    }
  };

  const handleSearch = (searchTerm) => {
    navigate('/menu-catalog', { state: { searchQuery: searchTerm } });
  };

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    setUser(null);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header
        cartCount={cartCount}
        user={user}
        onCartClick={handleCartClick}
        onAccountClick={handleAccountClick}
        onSearch={handleSearch}
        onLogout={handleLogout} />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="pt-16">

        <ReservationHero />
        
        {/* Call to Reserve Section */}
        <section className="py-8 bg-background pt-[30px] pb-10">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-card rounded-2xl shadow-warm-lg p-8 pt-0">

              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Icon name="Phone" size={40} className="text-primary" />
                </div>
                <p className="text-muted-foreground font-body mb-6">
                  Call us directly to make your reservation and speak with our friendly staff who will help you plan the perfect dining experience.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="tel:+19849994537"
                    className="inline-flex items-center space-x-3 bg-primary text-primary-foreground px-8 py-4 rounded-lg text-lg font-body font-semibold hover:bg-primary/90 transition-all duration-300 shadow-md hover:shadow-lg">
                    <Icon name="Phone" size={24} />
                    <span>Chapel Hill</span>
                  </a>
                  <a
                    href="tel:+19199730028"
                    className="inline-flex items-center space-x-3 bg-primary text-primary-foreground px-8 py-4 rounded-lg text-lg font-body font-semibold hover:bg-primary/90 transition-all duration-300 shadow-md hover:shadow-lg">
                    <Icon name="Phone" size={24} />
                    <span>Durham</span>
                  </a>
                </div>
              </div>

              <div className="border-t border-border pt-8">
                <h4 className="text-lg font-heading font-bold text-foreground mb-4 text-center">
                  When You Call, Please Have Ready:
                </h4>
                <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto pt-5">
                  <div className="flex items-start space-x-3">
                    <Icon name="Calendar" size={20} className="text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-body font-medium text-foreground">Preferred Date & Time</p>
                      <p className="text-sm text-muted-foreground font-body">We'll find the best available slot</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="Users" size={20} className="text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-body font-medium text-foreground">Party Size</p>
                      <p className="text-sm text-muted-foreground font-body">Number of guests in your party</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="MapPin" size={20} className="text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-body font-medium text-foreground">Location Preference</p>
                      <p className="text-sm text-muted-foreground font-body">Durham or Chapel Hill</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="Sparkles" size={20} className="text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-body font-medium text-foreground">Special Requests</p>
                      <p className="text-sm text-muted-foreground font-body">Occasions, dietary needs, etc.</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        <FooterSection />
      </motion.main>
    </div>);


};

export default Reservations;